import { TeamNameStep } from '~/components/MultiAccountManagement/Wizard/TeamNameStep';
import { EmptyFunction } from '~/adapters/typescript/emptyFunction';
import { useCallback } from 'react';
import Dialog from '@mui/material/Dialog'; // Intentionally importing from MUI and not Pigment, to separate Dialog and DialogTitle
import { useCreateAccount } from '~/adapters/services/accounts/accounts/hooks';
import { useUserAccount } from '~/contexts/UserAccount/UserAccountContext';

interface CreateTeamWizardProps {
    open: boolean;
    onClose: EmptyFunction;
}
export function CreateTeamWizard({ open, onClose }: CreateTeamWizardProps) {
    const { mutate } = useCreateAccount();
    const {
        user: { id: userId, email },
    } = useUserAccount();

    const handleSuccess = useCallback(
        (data: { teamName: string }) => {
            // If we don't specify email here, it's taken from JWT, which takes Inkers email when impersonating
            mutate({ name: data.teamName, userId, contactEmail: email });
            onClose();
        },
        [email, userId, mutate, onClose],
    );

    return (
        <Dialog open={open} onClose={onClose} fullWidth>
            <TeamNameStep onSuccess={handleSuccess} onClose={onClose} totalSteps={1} />
        </Dialog>
    );
}
